export default "__VITE_ASSET__B5t8DMPo__"